import { createDomain, type Scope, fork, sample } from 'effector';
import { getResidentParentList } from './api';
import type {
  GetResidentParentListPayload,
  GetResidentParentListResponse,
  GetList,
  Resident,
} from './types';

export const ControlDomain = createDomain();

const scopes: { [key: string]: Scope } = {};

export const createScope = (name: string) => {
  if (scopes[name]) {
    return scopes[name];
  }

  scopes[name] = fork(ControlDomain);

  return scopes[name];
};

export const getList = ControlDomain.createEvent<GetList>();

export const $data = ControlDomain.createStore<Resident[]>([]);
export const $pending = ControlDomain.createStore<boolean>(false);

export const fxGetResidentParentList = ControlDomain.createEffect<
  GetResidentParentListPayload,
  GetResidentParentListResponse,
  Error
>().use(getResidentParentList);

/** Запрос данных */
sample({
  clock: getList,
  fn: ({ areaGuid }) => ({ area_guid: areaGuid }),
  target: fxGetResidentParentList,
});

$pending.on(fxGetResidentParentList.pending, (_, pending) => pending);

$data.on(fxGetResidentParentList.done, (_, { result }) =>
  Array.isArray(result?.available_parent)
    ? result.available_parent.map((item) => ({
        id: item?.resident_guid,
        label: item?.username ?? '',
        ownershipId: item?.ownership_id ?? '',
      }))
    : []
);
